import { createFileRoute } from '@tanstack/react-router'

import { TaxDocuments } from '@/containers/taxDetails/components/TaxDocuments'

export const Route = createFileRoute(
  '/_authenticated/account/_accountDetails/taxDetails/documents'
)({
  beforeLoad: () => {
    return {
      breadCrumbTitle: 'Tax Documents',
    }
  },
  component: TaxDocuments,
})
